export var Languages;
(function (Languages) {
    Languages["EN_US"] = "en_US";
    Languages["FR_CA"] = "fr_CA";
})(Languages || (Languages = {}));
export var LanguagesArray = Object.keys(Languages).map(function (k) { return Languages[k]; });
//# sourceMappingURL=Languages.js.map